import { useMutation } from '@tanstack/react-query';

type ResetAdminUserPasswordParams = {
  id: number;
  password: string;
  passwordConfirmation: string;
};

export default function useResetAdminUserPassword() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement | undefined)
    ?.content;

  return useMutation({
    mutationFn: async (params: ResetAdminUserPasswordParams) => {
      const response = await fetch(`/admin/api/users/${params.id}/password_reset`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token || '',
        },
        body: JSON.stringify({
          admin_user: {
            password: params.password,
            password_confirmation: params.passwordConfirmation,
          },
        }),
      });
      if (!response.ok) {
        const body = await response.json().catch(() => null);
        const message =
          body?.errors?.length > 0 ? body.errors.join(', ') : 'パスワードのリセットに失敗しました';
        throw new Error(message);
      }
      return response.json();
    },
  });
}
